<div class="forgot-password-wrapper" fxLayout="column" fxLayoutGap="10px">
  <h4>
    Forgot Password
    <i
      class="fa fa-times pull-right close-sidenav"
      aria-hidden="true"
      title="Close Forgot Password"
      (click)="cancel()"
    ></i>
  </h4>

  <form [formGroup]="forgotPasswordForm" (ngSubmit)="submit()" fxLayout="column" fxLayoutGap="10px">
    @if (showLibraryLookupBox) {
      <div class="form-group">
        @if (!singleLibrary) {
          <label for="libraryLookup">Select Your Library</label>
          <mat-form-field class="width-100">
            <input
              #libraryInput
              matInput
              type="text"
              id="libraryLookup"
              placeholder="Select Your Library"
              aria-label="Select Your Library"
              [matAutocomplete]="auto"
              formControlName="lid"
              (focus)="onInputFocus()"
            />
            <button mat-icon-button matSuffix type="button" (click)="clearLibraryInput()">
              <mat-icon>{{ librariesControl.value ? 'clear' : 'keyboard_arrow_down' }}</mat-icon>
            </button>
            <mat-autocomplete
              #auto="matAutocomplete"
              autoActiveFirstOption
              autoSelectActiveOption
              (optionSelected)="onLibraryOptionSelected($event)"
            >
              @for (option of filteredLibraryOptions | async; track option) {
                <mat-option [value]="option">
                  {{ option }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (librariesControl.invalid && !librariesControl.pristine) {
              <mat-error>Please select a valid library</mat-error>
            }
          </mat-form-field>
        } @else {
          <label for="libraryReadonly">Your Library</label>
          <mat-form-field class="width-100">
            <input
              matInput
              type="text"
              id="libraryReadonly"
              aria-label="Your Library"
              readonly
              formControlName="lid"
            />
          </mat-form-field>
        }
      </div>
    }

    <div class="form-group">
      <label for="userName">{{ userNameLabel }}</label>
      <mat-form-field class="width-100">
        <input
          matInput
          type="text"
          title="User Name"
          [placeholder]="userNameLabel"
          [attr.aria-label]="userNameLabel"
          id="userName"
          formControlName="userName"
          cdkFocusInitial
          #user
        />
      </mat-form-field>
    </div>
    <button
      mat-button
      role="button"
      type="submit"
      aria-label="Submit"
      class="ag-mat-button-primary"
      fxFlexAlign="start"
      [disabled]="forgotPasswordForm.invalid"
    >
      Send
    </button>
  </form>
</div>
